import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
} from '@angular/core';
import { Datastore } from '@freelancer/datastore';
import { ModalRef } from '@freelancer/ui';
import { BannerAlertType } from '@freelancer/ui/banner-alert';
import { ButtonColor } from '@freelancer/ui/button';
import { HeadingSize, HeadingType } from '@freelancer/ui/heading';
import { Margin } from '@freelancer/ui/margin';
import { take } from 'rxjs/operators';

@Component({
  template: `
    <ng-container flTrackingSection="ProjectDeleteModal">
      <fl-bit class="Header">
        <fl-heading
          i18n="My project delete modal header"
          [size]="HeadingSize.XSMALL"
          [headingType]="HeadingType.H4"
          [flMarginBottom]="Margin.SMALL"
        >
          Delete project
        </fl-heading>
      </fl-bit>
      <fl-bit class="MainBody">
        <fl-text
          i18n="My project delete modal body"
          [flMarginBottom]="Margin.SMALL"
        >
          By deleting your project, no one will be able to view the project
          information, the attached files nor any of the bids on the project.
        </fl-text>
      </fl-bit>
      <fl-banner-alert
        *ngIf="showError"
        i18n="My project delete modal error alert"
        [type]="BannerAlertType.ERROR"
        [closeable]="false"
        [flMarginBottom]="Margin.XXSMALL"
      >
        There was a problem deleting your project. Please try again or contact
        support.
      </fl-banner-alert>
      <div class="ActionContainer">
        <fl-button
          class="ActionButton"
          i18n="My project delete modal cancel button"
          flTrackingLabel="CancelButton"
          [color]="ButtonColor.DEFAULT"
          [flMarginRight]="Margin.SMALL"
          (click)="cancel()"
        >
          Cancel
        </fl-button>
        <fl-button
          class="ActionButton"
          i18n="My project delete modal delete button"
          flTrackingLabel="DeleteButton"
          [busy]="isBusy"
          [color]="ButtonColor.SECONDARY"
          (click)="confirm()"
        >
          Delete
        </fl-button>
      </div>
    </ng-container>
  `,
  styleUrls: ['./project-delete-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProjectDeleteModalComponent {
  Margin = Margin;
  BannerAlertType = BannerAlertType;
  ButtonColor = ButtonColor;
  HeadingSize = HeadingSize;
  HeadingType = HeadingType;
  isBusy = false;
  showError = false;

  @Input() projectId: number;

  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    private modalRef: ModalRef<ProjectDeleteModalComponent>,
    private datastore: Datastore,
  ) {}

  confirm() {
    this.isBusy = true;
    const projectDoc = this.datastore.document('projects', this.projectId);

    projectDoc
      .valueChanges()
      .pipe(take(1))
      .toPromise()
      .then(_ => {
        projectDoc.remove().then(response => {
          if (response.status === 'success') {
            this.modalRef.close(true);
            this.isBusy = false;
          } else {
            this.isBusy = false;
            // this.error = error.message;
            // use generic error message for now since error.message is gibberish
            this.showError = true;
            this.changeDetectorRef.markForCheck();
          }
        });
      });
  }

  cancel() {
    this.modalRef.close(false);
  }
}
